module.exports = __webpack_public_path__ + "static/media/pirl.8382aa84.svg";